import { ApiError } from '../../model';
import { errorInterceptorHandler } from '../../utils';
import { isAbortError } from './abort-error.util';

interface CreateApiErrorArgs {
  message: string;
  originalError?: Error;
  response?: Response;
  url: string;
}

export const createApiError = ({
  message,
  originalError,
  response,
  url,
}: CreateApiErrorArgs): ApiError<unknown> => {
  const error = new Error(message) as ApiError<unknown>;

  error.config = {
    url,
  };

  if (response) {
    const headers: Record<string, string> = {};

    response.headers.forEach((value, key) => {
      headers[key] = value;
    });

    error.response = {
      config: {},
      data: null,
      headers,
      status: response.status,
      statusText: response.statusText,
    };
  }

  if (originalError) {
    error.cause = originalError;
  }

  return error;
};

export const handleFetchError = async (error: unknown, fullUrl: string): Promise<never> => {
  if (isAbortError(error)) {
    throw error;
  }

  const caughtError = error as ApiError<unknown>;

  if (caughtError.response) {
    throw caughtError;
  }

  const apiError = createApiError({
    message: `Network or other error when requesting ${fullUrl}`,
    originalError: error as Error,
    url: fullUrl,
  });

  await errorInterceptorHandler(apiError);

  throw apiError;
};
